// types
import type { BaseAvatarsProps, StandardAvatarsProps } from './AvatarsTypes';

export type { BaseAvatarsProps, StandardAvatarsProps };

// components
export { StandardAvatars } from './standard';
